export const REPORT_COMMENT_REQUEST = 'comment/REPORT_REQUEST';
export const REPORT_COMMENT_SUCCESS = 'comment/REPORT_SUCCESS';
export const REPORT_COMMENT_FAILURE = 'comment/REPORT_FAILURE';

export function reportComment(report = {}) {
  return (dispatch, getState, { request }) => {
    dispatch({
      type: REPORT_COMMENT_REQUEST,
    });

    const promise = request.post(`/posts/${report.postId}/comments/${report.commentId}/report`, {
      reportType: report.reportType,
    });

    return promise
      .then(() =>
        dispatch({
          type: REPORT_COMMENT_SUCCESS,
          payload: {
            _id: report.commentId,
            reportType: report.reportType,
          },
        }),
      )
      .catch(() =>
        dispatch({
          type: REPORT_COMMENT_FAILURE,
        }),
      )
      .then(() => promise);
  };
}
